import type { Transaction } from './Transactions.types'

export const transactionTypeTexts: Record<Transaction['type'], string> = {
  AFFILIATE_REFERRAL_BONUS: 'Affiliate referral bonus',
  CREATOR_BUDGET: 'Samples order',
  CREATOR_CHARGE: 'Payment method charge',
  DONATION: 'Donation',
  DONATION_CANCEL: 'Donation cancel',
  GIFT_FROM_GIVEAWAY: 'Twitch gift redemption',
  GIFT_ON_CREATOR_COST: 'Giveaway links',
  GIVEAWAY_PURCHASE: 'Twitch gift purchase',
  INVENTORY_SHIPMENT: 'Inventory shipment',
  INVENTORY_STORAGE: 'Inventory storage',
  MANUAL_BONUS: 'Bonus',
  MANUAL_CHARGE: 'Charge',
  MANUAL_DISPUTE: 'Dispute',
  MANUAL_PAID_INVOICE: 'Paid invoice',
  MANUAL_PAYOUT: 'Payout',
  MANUAL_PAYOUT_REVERTED: 'Payout reverted',
  MANUAL_PRODUCTION_DISCOUNT: 'Production discount',
  MEMBERSHIP_GIFT_PURCHASE: 'Membership gift purchase',
  MEMBERSHIP_GIFT_REDEEM: 'Membership gift redemption',
  MEMBERSHIP_LOCKED_MESSAGE: 'Memberships locked message',
  MEMBERSHIP_TIP: 'Memberships tip',
  ORDER: 'Order',
  ORDER_CANCEL: 'Order cancellation',
  ORDER_PARTIAL_CANCEL: 'Partial order cancellation',
  ORDER_REFUND: 'Order refund',
  REQUESTED_PAYOUT: 'Requested payout',
  REVERTED_PAYOUT: 'Reverted payout',
  SAAS_PAYMENT: 'Fourthwall Pro payment',
  SAAS_PAYMENT_REVERT: 'Fourthwall Pro payment revert',
  SCHEDULED_PAYOUT: 'Scheduled payout',
  SUBSCRIPTION_CHARGE: 'Memberships charge',
  SUBSCRIPTION_REFUND: 'Memberships refund',
}
